import { useUnifiedPopup } from '../UnifiedPopup/UnifiedPopup';
import DotsBalance from '../DotsBalance/DotsBalance';
import { useDotsBalance } from '@/hooks/useDotsBalance';
import { useAuth } from '@/contexts/AuthContext';

interface Popup1Props {
  popupType: 'joydropBonus' | 'joiningBonus' |'streakBonus';
  balance: number;
  onBack: () => void;
}

export default function Popup1({ popupType, balance, onBack }: Popup1Props) {
  const { openPopup, closePopup } = useUnifiedPopup();
  const { token } = useAuth();
  const { tasks, daysLeft, loading, error, refreshData } = useDotsBalance(token);

  const handleBalanceClick = () => {
    openPopup({
      id: 'dotsBalance',
      type: 'custom',
      position: 'center',
      size: 'lg',
      closeOnOverlayClick: true,
      props: {
        content: (
          <DotsBalance
            balance={balance}
            tasks={tasks}
            daysLeft={daysLeft}
            loading={loading}
            error={error}
            onRefresh={refreshData}
            onClose={() => closePopup('dotsBalance')}
          />
        ),
      },
      zIndex: 200,
    });
  };
  return (
    // Overlay (fullscreen, dull background, center everything)
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      {/* Popup Container */}
      <div className="w-full max-w-[620px] h-auto rounded-xl  flex flex-col p-6 gap-6 ">
        
        {/* Header Row */}
        <div className="flex justify-between items-center gap-4 text-white-800 font-bold text-[16px]">
          <span onClick={onBack} className="cursor-pointer">← Back</span>
          {/* <span onClick={handleBalanceClick} className="cursor-pointer">Balance</span> */}
         
        </div>

        {/* Popup Image with Border */}
        {popupType === 'joiningBonus' && (
          <img
          src="/PopUp/joining-bonus.svg"
          alt="confetti"
          className="w-full max-w-[620px] h-auto 
            rounded-[12px] 
            border-t-[1px] border-r-[3px] border-b-[3px] border-l-[1px] 
            border-solid border-[#1F2937]"
        />
        )}
        {popupType === 'streakBonus' && (
          <img
            src="/PopUp/streak-bonus.svg"
            alt="confetti"
            className="w-full max-w-[620px] h-auto 
              rounded-[12px] 
              border-t-[1px] border-r-[3px] border-b-[3px] border-l-[1px] 
              border-solid border-[#1F2937]"
          />
        )}
        {popupType === 'joydropBonus' && (
          <img
            src="/PopUp/joydrop-bonus.svg"
            alt="confetti"
            className="w-full max-w-[620px] h-auto 
              rounded-[12px] 
              border-t-[1px] border-r-[3px] border-b-[3px] border-l-[1px] 
              border-solid border-[#1F2937]"
          />
        )}
        
      </div>
    </div>
  );
}
